import { Controller, FieldValues } from 'react-hook-form'

import { TransferList } from './TransferList'
import { TransferListConatinerProps } from './types'

export const TransferListController = <T extends FieldValues>({
  all,
  control,
  disabled,
  maxActive,
  name,
}: TransferListConatinerProps<T>): JSX.Element => (
  <Controller
    control={control}
    name={name}
    render={({ field: { onChange, value } }): JSX.Element => (
      <TransferList
        all={all}
        disabled={disabled}
        maxActive={maxActive}
        onChange={onChange}
        value={value}
      />
    )}
  />
)
